import React from "react";
import { Colors } from "../../../utils/colors";
import { TCText } from "../../../components/TCText/TCText";

type props = {
  title?: string;
  measurement?: string;
  subtitle?: string;
};

export const CourtCoverageDescBox: React.FC<props> = ({
  title,
  measurement,
  subtitle,
}) => {
  return (
    <div style={styles.box}>
      {title ? <TCText style={styles.title} value={title} /> : null}
      <div style={styles.descContainer}>
        {measurement ? (
          <TCText style={styles.measurement} value={measurement} />
        ) : null}
        {subtitle ? <TCText style={styles.subtitle} value={subtitle} /> : null}
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  box: {
    flex: 1,
    backgroundColor: Colors.lightGreyBackground,
    borderRadius: 16,
    paddingTop: 12,
    paddingBottom: 12,
    paddingLeft: 15,
    paddingRight: 15,
  },
  title: {
    fontWeight: "400",
    fontSize: 12,
    color: Colors.black,
  },
  descContainer: {
    display: "flex",
    alignItems: "baseline",
    gap: 5,
  },
  measurement: {
    fontWeight: "600",
    fontSize: 24,
    color: Colors.black,
    textAlign: "center",
  },
  subtitle: {
    fontWeight: "400",
    fontSize: 12,
    color: Colors.black,
    textAlign: "center",
  },
};
